import Participant from '@app/store/documents/Participant';
import SigningMethodType from '@app/store/SigningMethodType';

export default function isUserCurrentSigner({
  currentUserContact,
  currentSigningOrder,
  participants,
  signings,
}: {
  currentUserContact: string | null;
  currentSigningOrder: number;
  participants: Array<Pick<Participant, 'signingMethod' | 'signingOrder' | 'participantId'>>;
  signings: Array<{ participantId: string; expiredAt: string | null }>;
}) {
  if (!currentUserContact) return false;

  return participants
    .filter(
      (p) =>
        p.signingOrder === currentSigningOrder &&
        p.signingMethod.contactInfo === currentUserContact &&
        !signings
          .filter((signing) => !signing.expiredAt)
          .some((s) => s.participantId === p.participantId)
    )
    .some((p) => p.signingMethod.methodType !== SigningMethodType.IN_PERSON);
}
